import React from "react";
import { useGetMeaningQuery } from "../../services/wordsApi";

const WordCards = ({word}) => {
  const {data} = useGetMeaningQuery(word);
  console.log(data["results"]);
  return (
    <>
      <h1>All Meanings of Cards are here</h1>
    </>
  );
};

export default WordCards;
